// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"351":"commons","532":"styles","678":"component---src-pages-index-js"}[chunkId] || chunkId) + "-" + {"351":"6fe52577bd3d90086299","532":"9c7f0b2652b706c6cc30","678":"c9793b55ccff170b50fb","731":"51b35999f4e71c6073d8","843":"a5ab8948d6ec0b5be40f"}[chunkId] + ".js";
};